import React, { useState } from "react";
import {
    Box,
    Button,
    Modal,
    Typography,
    Stack,
    Paper,
    IconButton,
    CircularProgress,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { uploadFile } from "../../../utils/helper/appHelpers";
import { FILE_UPLOAD_DIR } from "../../../utils/Constant";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import { apiRequest } from "../../../utils/config/apiRequest";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: 24,
    p: 3,
};

export default function SoftCopy({
    open,
    onClose,
    title = "Upload File",
    accept = "*",
    loading = false,
    email = "",
    name = "",
    userId = "",
    orderNo = ""
}) {
    const [file, setFile] = useState(null);

    const handleSelectFile = (event) => {
        if (event.target.files?.length) {
            setFile(event.target.files[0]);
        }
    };

    const handleSend = () => {
        if (!file) return;
        onSend(file);
    };

    const onSend = async () => {
        const formData = new FormData();
        formData.append('file', file);

        let { data, status } = await apiRequest({
            method: "POST",
            endUrl: apiUrl.uploadFile(FILE_UPLOAD_DIR.SHOP),
            body: formData,
            headerType: 'form'
        });

        if (status) {
            const resp = await apiRequest({
                method: "POST",
                endUrl: apiUrl.orders.sendsoftcopy,
                body: {
                    url: data?.shortUrl,
                    email,
                    name,
                    userId,
                    orderNo
                },
                showMsg: true
            });

            onClose()
        }
    }
    const handleClose = () => {
        setFile(null);
        onClose();
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                <Typography variant="h6" fontWeight={600} mb={3}>
                    {title}
                </Typography>

                <Paper
                    variant="outlined"
                    sx={{
                        width:'100%',
                        p: 4,
                        textAlign: "center",
                        borderStyle: "dashed",
                        cursor: "pointer",
                        bgcolor: "#fafafa",
                    }}
                    component="label"
                >
                    <UploadFileIcon sx={{ fontSize: 45, color: "primary.main" }} />

                    <Typography mt={1} fontWeight={500}>
                        Click to select a file
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        Drag & Drop or Browse
                    </Typography>

                    <input
                        hidden
                        type="file"
                        accept={accept}
                        onChange={handleSelectFile}
                    />
                </Paper>

                {file && (
                    <Paper
                        sx={{
                            mt: 2,
                            p: 1.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Stack direction="row" spacing={1} alignItems="center">
                            <InsertDriveFileIcon color="primary" />

                            <Typography
                                variant="body2"
                                sx={{
                                    maxWidth: 260,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {file.name}
                            </Typography>
                        </Stack>

                        <IconButton size="small" onClick={() => setFile(null)}>
                            <CloseIcon />
                        </IconButton>
                    </Paper>
                )}

                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="flex-end"
                    mt={4}
                >
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        disabled={!file || loading}
                        onClick={handleSend}
                        startIcon={
                            loading ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : (
                                <UploadFileIcon />
                            )
                        }
                    >
                        {loading ? "Uploading..." : "Send"}
                    </Button>
                </Stack>
            </Box>
        </Modal>
    );
}